// eslint-disable-next-line import/prefer-default-export
import { autocompleteAddressMock, captureAddressMock } from './AddressMock';

const { REACT_APP_ADDRESS_AUTO_COMPLETE_API_ENDPOINT: ADDRESS_API, REACT_APP_ADDRESS_AUTO_COMPLETE_API_TOKEN, REACT_APP_ADDRESS_AUTO_COMPLETE_MOCK } = process.env;

export const autocompleteAddress = async (searchText: string): Promise<any> => {
  if (process.env.NODE_ENV === 'development' || REACT_APP_ADDRESS_AUTO_COMPLETE_MOCK === 'true') {
    return autocompleteAddressMock();
  }

  const myHeaders = new Headers();
  myHeaders.append('Auth-Token', REACT_APP_ADDRESS_AUTO_COMPLETE_API_TOKEN!);
  const results = await fetch(`${ADDRESS_API}search?country=AUS&query=${searchText}`, {
      method: 'GET',
      headers: myHeaders,
  });
  const json = await results.json();
  return json;
};

export const captureAddress = async (url: string): Promise<any> => {
  if (process.env.NODE_ENV === 'development' || REACT_APP_ADDRESS_AUTO_COMPLETE_MOCK === 'true') {
    return captureAddressMock();
  }
  const myHeaders = new Headers();
  myHeaders.append('Auth-Token', REACT_APP_ADDRESS_AUTO_COMPLETE_API_TOKEN!);
  const results = await fetch(url, {
    method: 'GET',
    headers: myHeaders,
  });
  const json = await results.json();
  return json;
};
